const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/genres/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/genres/")({
  loader: lazyFn($$splitLoaderImporter, 'loader')
});